import {
  CurrencyDollarIcon,
  GlobeAmericasIcon,
  PhoneIcon,
} from "@heroicons/react/20/solid";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Popup from "../../components/Popup";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import { Navigation, Thumbs } from "swiper/modules";

function Product(props) {
  let { productID } = useParams();
  const [product, setProduct] = useState({});
  const [modal, setModalShow] = useState(false);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const navigate = useNavigate();

  const policies = [
    {
      name: "Kategorie",
      icon: GlobeAmericasIcon,
      description: [product?.category],
    },
    {
      name: "Verkauft durch",
      icon: CurrencyDollarIcon,
      description: [product?.vendor],
    },
    {
      name: "Kontakt",
      icon: PhoneIcon,
      description: [
        product?.contactPreferenceTelefon,
        product?.contactPreferenceEmail,
      ],
    },
  ];

  useEffect(() => {
    axios
      .get("https://dealersonly.parts/beta/api/product/" + productID)
      .then((res) => {
        setProduct(res.data[0]);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  console.log(product);
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });
  console.log(product);
  const placeholderImage =
    "https://dealersonly.parts/beta/app/files/DopePlaceholder.png";

  const hasImages =
    product.productImages &&
    product.productImages.length > 0 &&
    product.productImages[0] !== "";

  return (
    <main className="mx-auto max-w-7xl sm:px-6 sm:pt-16 lg:px-8 pb-24">
      <button
        onClick={() => navigate(-1)}
        type="button"
        className="text-indigo-600 font-medium place-self-start"
      >
        <span aria-hidden="true">←</span>
        Zurück zur Übersicht
      </button>
      {product.length !== 0 ? (
        <div className="mx-auto max-w-2xl lg:max-w-none">
          {/* Product */}
          <div className="lg:grid lg:grid-cols-2 lg:items-start lg:gap-x-8">
            {/* Image gallery */}
            <div className="mt-10 lg:row-span-2 lg:mt-0 lg:self-center">
              <Swiper
                spaceBetween={10}
                navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                className="main-swiper"
                modules={[Navigation, Thumbs]}
              >
                {hasImages ? (
                  product.productImages.map((img, index) => (
                    <SwiperSlide key={index}>
                      <img
                        src={`https://dealersonly.parts/beta/app/${img}`}
                        alt={product.description}
                        className="h-full w-full object-contain object-center"
                      />
                    </SwiperSlide>
                  ))
                ) : (
                  <SwiperSlide>
                    <img
                      src={placeholderImage}
                      alt="Placeholder"
                      className="h-full w-full object-contain object-center"
                    />
                  </SwiperSlide>
                )}
              </Swiper>
              {hasImages && (
                <Swiper
                  onSwiper={setThumbsSwiper}
                  spaceBetween={10}
                  slidesPerView={4}
                  freeMode={true}
                  watchSlidesProgress={true}
                  modules={[Navigation, Thumbs]}
                  className="thumbs-swiper mt-4"
                >
                  {product.productImages.map((img, index) => (
                    <SwiperSlide
                      key={index}
                      className="w-16 h-16 border-2 rounded-lg overflow-hidden"
                    >
                      <img
                        src={`https://dealersonly.parts/beta/app/${img}`}
                        alt={`Thumbnail ${index + 1}`}
                        className="h-full w-full object-contain object-center"
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              )}
            </div>
            {/* Product info */}
            <div className="mt-10 px-4 sm:mt-16 sm:px-0 lg:mt-0">
              <h1 className="text-3xl font-bold tracking-tight text-gray-900">
                {product.selector === "suchanfragen"
                  ? "Gesucht wird " + product.title
                  : product.title}
              </h1>

              {product.selector !== "suchanfragen" && (
                <div className="mt-3">
                  <h2 className="sr-only">Artikelinformationen</h2>
                  <p className="text-3xl tracking-tight text-gray-900">
                    {formatter.format(product.price)}
                  </p>
                </div>
              )}

              <section aria-labelledby="policies-heading" className="mt-10">
                <h2 id="policies-heading" className="sr-only">
                  Informationen
                </h2>

                <dl className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
                  <div className="rounded-lg border border-gray-200 p-4">
                    <dt>
                      <span className="mt-4 text-sm font-medium text-gray-900">
                        Zustand {product.zustand}
                      </span>
                    </dt>
                  </div>
                  <div className="rounded-lg border border-gray-200 p-4">
                    <dt>
                      <span className="mt-4 text-sm font-medium text-gray-900">
                        {product.oem} Part
                      </span>
                    </dt>
                  </div>
                </dl>
              </section>

              <div className="mt-10">
                <h2 className="text-sm font-medium text-gray-900">
                  Beschreibung
                </h2>

                <div
                  className="prose prose-sm mt-4 text-gray-500"
                  dangerouslySetInnerHTML={{ __html: product.description }}
                />
              </div>

              <div className="mt-10 border-t border-gray-200 pt-10">
                <h3 className="text-sm font-medium text-gray-900">
                  Bestell- & Teilenummern
                </h3>
                <div className="prose prose-sm mt-4 text-gray-500">
                  <ul role="list">
                    {product?.teileNummer?.map((highlight) => (
                      <li key={highlight}>{highlight}</li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* <div className="mt-6">
                <div className="mt-12 flex">
                  <button
                    type="button"
                    onClick={() => {
                      setModalShow(true);
                    }}
                    className="flex flex-1 items-center justify-center rounded-md border border-transparent bg-indigo-600 py-3 px-8 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-50 sm:w-full"
                  >
                    {product.selector === "suchanfragen"
                      ? "Artikel anbieten"
                      : "Anbieter kontaktieren"}
                  </button>
                </div>
              </div> */}
            </div>
            <section aria-labelledby="policies-heading" className="mt-10">
              <h2 id="policies-heading" className="sr-only">
                Informationen
              </h2>

              <dl className="grid grid-cols-1 gap-6 sm:grid-cols-23 lg:grid-cols-1 xl:grid-cols-3">
                {policies?.map((policy) => (
                  <div
                    key={policy.name}
                    className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-center"
                  >
                    <dt>
                      <policy.icon
                        className="mx-auto h-6 w-6 flex-shrink-0 text-gray-400"
                        aria-hidden="true"
                      />
                      <span className="mt-4 text-sm font-medium text-gray-900">
                        {product.selector === "suchanfragen" &&
                        policy.name === "Verkauft durch"
                          ? "Gesucht von"
                          : policy.name}
                      </span>
                    </dt>
                    <dd className="mt-1 text-sm text-gray-500">
                      {policy.description?.length > 1
                        ? policy.description.map((el) => <p>{el}</p>)
                        : policy.description}
                    </dd>
                  </div>
                ))}
              </dl>
            </section>
          </div>

          <Popup
            open={modal}
            onHide={() => setModalShow(false)}
            id={product._id}
            product={product}
          />
        </div>
      ) : (
        <div>Part nicht gefunden</div>
      )}
    </main>
  );
}

export default Product;
